export default __webpack_public_path__ + "static/media/hero-cta-icon-startup.aa5fd006.svg";